import { FileText, Calendar, Search, Bot, TrendingUp, Clock } from 'lucide-react';
import { type AITaskType } from '@/hooks/useAI';

export const assistants = [
  {
    id: 'case_analysis' as AITaskType,
    title: 'Análise de Processos',
    description: 'Analise processos, identifique riscos e oportunidades',
    icon: TrendingUp,
    color: 'bg-primary/10 text-primary border-primary/20',
    examples: [
      'Analise os pontos críticos deste processo',
      'Identifique riscos e oportunidades',
      'Sugira estratégias processuais'
    ]
  },
  {
    id: 'document_generation' as AITaskType,
    title: 'Geração de Documentos',
    description: 'Crie petições, contratos e documentos jurídicos',
    icon: FileText,
    color: 'bg-secondary/10 text-secondary border-secondary/20',
    examples: [
      'Gere uma petição inicial',
      'Redija um contrato personalizado',
      'Elabore uma defesa processual'
    ]
  },
  {
    id: 'deadline_management' as AITaskType,
    title: 'Gestão de Prazos',
    description: 'Gerencie prazos e calcule datas importantes',
    icon: Clock,
    color: 'bg-warning/10 text-warning border-warning/20',
    examples: [
      'Calcule prazos processuais',
      'Identifique urgências',
      'Crie cronograma de prazos'
    ]
  },
  {
    id: 'legal_research' as AITaskType,
    title: 'Pesquisa Jurídica',
    description: 'Pesquise jurisprudência e legislação',
    icon: Search,
    color: 'bg-tertiary/10 text-tertiary border-tertiary/20',
    examples: [
      'Pesquise jurisprudência relevante',
      'Encontre precedentes',
      'Analise legislação aplicável'
    ]
  },
  {
    id: 'general' as AITaskType,
    title: 'Assistente Geral',
    description: 'Ajuda geral com questões jurídicas e administrativas',
    icon: Bot,
    color: 'bg-muted/10 text-muted-foreground border-muted/20',
    examples: [
      'Explique conceitos jurídicos',
      'Dê sugestões administrativas',
      'Tire dúvidas gerais'
    ]
  }
];

export const quickActions = [
  {
    title: 'Análise Rápida de Caso',
    description: 'Faça uma análise preliminar de qualquer processo',
    action: (setSelectedAssistant: (type: AITaskType) => void, setActiveTab: (tab: string) => void) => {
      setSelectedAssistant('case_analysis');
      setActiveTab('assistants');
    },
    icon: TrendingUp,
    color: 'bg-primary text-primary-foreground'
  },
  {
    title: 'Gerar Documento',
    description: 'Crie documentos jurídicos em segundos',
    action: (setSelectedAssistant: (type: AITaskType) => void, setActiveTab: (tab: string) => void) => {
      setSelectedAssistant('document_generation');
      setActiveTab('assistants');
    },
    icon: FileText,
    color: 'bg-secondary text-secondary-foreground'
  },
  {
    title: 'Verificar Prazos',
    description: 'Analise e gerencie seus prazos processuais',
    action: (setSelectedAssistant: (type: AITaskType) => void, setActiveTab: (tab: string) => void) => {
      setSelectedAssistant('deadline_management');
      setActiveTab('assistants');
    },
    icon: Clock,
    color: 'bg-warning text-warning-foreground'
  },
  {
    title: 'Pesquisa Jurídica',
    description: 'Encontre jurisprudência e legislação relevante',
    action: (setSelectedAssistant: (type: AITaskType) => void, setActiveTab: (tab: string) => void) => {
      setSelectedAssistant('legal_research');
      setActiveTab('assistants');
    },
    icon: Search,
    color: 'bg-tertiary text-tertiary-foreground'
  }
];